import React from "react"
import { Link, realPath } from "lib"
import MainMenu, { useMainMenu } from "./MainMenu"
import MobileMenu from "./MobileMenu"
import SearchBar from "./SearchBar"

const Header = ({ node, language, first }) => {
    const menu = useMainMenu()
    return (
      <>
        <header role="banner" id="header" key="header">
            <Link id="logo" to="/">
                <img src={realPath("/img/logo.png")} alt="Logo" />
                <div className="site-name">
                    <div className="line1">Primăria Comunei</div>
                    <div className="line2">Telciu</div>
                    <div className="line3">Bistrița-Năsăud</div>
                </div>
            </Link>

            <div className="header-in">
                <MainMenu id="main-menu" menu={menu} language={language} />
                <MobileMenu menu={menu} />
            </div>
           <div id="search-bar-out">
                <SearchBar/>
                <Link id="fiipregatit" to="https://fiipregatit.ro" target="_blank">
                  <img src={realPath("/img/LogoDsu.png")} alt="Fii pregatit" />
                  <div>fiipregatit.ro</div>
                </Link>
           </div>
        </header>
      </>
    )
}
export default React.memo(Header)
